import styled from 'styled-components';

export const SelectCityWrapper = styled.div`
  max-width: 647px;
`;
